module.exports = __webpack_public_path__ + "img/logo_sas_portrait.90f76887.svg";